import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type PriorityLevel = 'high' | 'medium' | 'low';

export interface HomepageRecommendation {
  id: string;
  title: string;
  description: string;
  priority: PriorityLevel;
  actionLabel: string;
  actionUrl?: string;
}

@Component({
  selector: 'app-homepage-recommendation-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './homepage-recommendation-card.component.html',
  styleUrls: ['./homepage-recommendation-card.component.scss']
})
export class HomepageRecommendationCardComponent {
  @Input() recommendation!: HomepageRecommendation;
  @Output() actionClick = new EventEmitter<HomepageRecommendation>();

  get priorityLabel(): string {
    switch (this.recommendation.priority) {
      case 'high':
        return 'High Priority';
      case 'medium':
        return 'Medium Priority';
      case 'low':
        return 'Low Priority';
      default:
        return 'Priority';
    }
  }

  get priorityClass(): string {
    return `priority-${this.recommendation.priority}`;
  }

  onActionClick(): void {
    this.actionClick.emit(this.recommendation);
  }
}
